import { TRACKER } from 'constants/constants';
import { MIXPANEL_EVENT_NAMES } from 'constants/mixpanelEventNames';
import { trackMixpanelEvent } from 'helpers/mixpanel-init';
import { APP_DRAWER_TAB_ID_MAPPING } from 'reducers/initialstate/appDrawer';
import { appDrawerSelector } from 'selectors/otherSelectors';
import { useAppSelector } from 'storeHooks';
import { AngleRightIcon } from 'styles/assets/icons';

import styles from './index.module.scss';

interface TrackerInfoProps {
  setShowTrackerIntro: (show: boolean) => void;
}

const TrackerInfo = ({ setShowTrackerIntro }: TrackerInfoProps) => {
  const { activeTab } = useAppSelector(appDrawerSelector);

  const mapTabNamesWithSourceName = {
    [APP_DRAWER_TAB_ID_MAPPING.MARKETS]: 'markets',
    [APP_DRAWER_TAB_ID_MAPPING.TRADE]: 'trade',
    [APP_DRAWER_TAB_ID_MAPPING.CHART_ORDERBOOK]: 'chart',
  };

  const pageSource = mapTabNamesWithSourceName[activeTab];

  const onTrackerInfoClick = () => {
    trackMixpanelEvent(MIXPANEL_EVENT_NAMES.TRACKER.WHAT_ARE_TRACKERS_CLICKED, {
      source: pageSource,
    });
  };

  return (
    (<div
      data-testid="tracker-info"
      className={styles['tracker-intro']}
      onClick={onTrackerInfoClick}
      onKeyDown={e => {
        if (e.key === 'Enter' || e.key === ' ') {
          onTrackerInfoClick();
        }
      }}
      role="button"
      tabIndex={0}
      data-palette="TrackerInfo">
      <button
        data-testid="tracker-intro-button"
        onClick={() => setShowTrackerIntro(true)}
        type="button"
      >
        {TRACKER.WHAT_ARE_TRACKERS} <AngleRightIcon className={styles.chevronRight} />
      </button>
    </div>)
  );
};
export default TrackerInfo;
